import { create } from "zustand";
import type { TokenGenerator, UserProfileStore } from "./user-profile.types";

export const useUserProfileStore = create<UserProfileStore>((set) => ({
  tokenGenerator: null,

  setTokenGenerator: (tokenGenerator: TokenGenerator | null) => set({ tokenGenerator }),
}));

export const useTokenGenerator = () => useUserProfileStore((state) => state.tokenGenerator);
export const useSetTokenGenerator = () => useUserProfileStore((state) => state.setTokenGenerator);
export const useHasTokenGenerator = (): boolean => useUserProfileStore((state) => !!state.tokenGenerator);

export const getAuthToken = async (): Promise<string | null> => {
  const tokenGenerator = useUserProfileStore.getState().tokenGenerator;
  if (!tokenGenerator) {
    throw new Error("[getAuthToken] Token generator not initialized");
  }

  return tokenGenerator();
};
